import React from 'react';

export default function Admin() {
  return (
    <div style={{ padding: 20 }}>
      <h2>Admin Panel</h2>
      <p>Manage users, settings, and see audit logs here.</p>
      <p>(Coming soon…)</p>
    </div>
  );
}
